<bodyanalytics-field-label
  [for]="inputId()"
  [text]="label()"
  [required]="required()"
  [hint]="hint()"></bodyanalytics-field-label>

<div class="field-input" [class.field-input--has-suffix]="!!suffix()">
  <input
    class="field-input__control"
    [class.field-input__control--invalid]="invalid()"
    [id]="inputId()"
    [type]="type()"
    [placeholder]="placeholder()"
    [required]="required()"
    [disabled]="disabled()"
    [value]="value() ?? ''"
    [attr.autocomplete]="autocomplete() ?? null"
    [attr.inputmode]="inputmode() ?? null"
    [attr.aria-invalid]="invalid() ? 'true' : null"
    [attr.aria-describedby]="describedBy()"
    (input)="handleInput($event)"
    (blur)="handleBlur()" />
  @if (suffix(); as s) {
    <span class="field-input__suffix" aria-hidden="true">{{ s }}</span>
  }
</div>

@if (belowHint(); as h) {
  <p class="field-input__hint" [id]="hintId()">{{ h }}</p>
}

@if (error(); as e) {
  <p class="field-input__error" role="alert" [id]="errorId()">
    <i class="bx bx-error-circle" aria-hidden="true"></i>
    {{ e }}
  </p>
}
